export const ActionType = {
  SET_STORE_MESSAGE_RECEIVED:"SET_STORE_MESSAGE_RECEIVED",
  SET_STORE_MESSAGE:"SET_STORE_MESSAGE",
  ADD_CHAT_MESSAGE:"ADD_CHAT_MESSAGE"
}
export const setStoreMessageReceived = (payload) => {
  return{
    type: ActionType?.SET_STORE_MESSAGE_RECEIVED,
    payload: payload,
  }
}
export const setStoreMessage = (payload) => {
  return{
    type: ActionType?.SET_STORE_MESSAGE,
    payload: payload,
  }
}


export const setAddMessageNew = (payload) => async (dispatch) => {
  dispatch({
    type: ActionType?.ADD_CHAT_MESSAGE,
    payload: payload,
  });
};
